export interface UpdateUserSettingInputApiModel{
    setting_key: string,
    setting_data: any
}